import {observer} from "mobx-react-lite";
import {Fragment, useState} from "react";
import {
    Col,
    Form,
    Modal,
    Row,
    Tabs,
    Image,
    Typography,
    Button, Space
} from "antd";
import {AddCompanyStore, CommonStore, HomeStore} from "../../store";
import "./index.css";
import dictionary from "../../utils/dictionary";

function RowDetail() {
    const form = Form.useFormInstance();
    const tabsItem = [
        {
            label: "账户信息",
            key: "1",
            show:['account'],
            children: (
                <div>
                    <Form form={form} labelWrap>
                        <Row justify="start">
                            <Col span={8}>
                                <Form.Item label="企业账户名称">
                                    {HomeStore.detailData?.businessAccountName}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="客户经理">
                                    {HomeStore.detailData?.customerManagerCode}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="签约公司">
                                    {HomeStore.detailData?.signingCompany}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="联系人姓名">
                                    {HomeStore.detailData?.contactName}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="联系人电话">
                                    {HomeStore.detailData?.contactPhoneNumber}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="联系人邮箱">
                                    {HomeStore.detailData?.contactEmail}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            ),
        },
        {
            label: "企业实名",
            key: "2",
            show:['enterprise'],
            children: (
                <div style={{maxHeight: "calc(100vh - 200px)", overflow: "auto",}}>
                    <Form form={form} labelWrap>
                        <Row justify="start">
                            <Col span={8}>
                                <Form.Item label="统一社会信用代码">
                                    {HomeStore.detailData.customerCreditCode}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="企业名称">
                                    {HomeStore.detailData.customerName}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="注册资金">
                                    {HomeStore.detailData.registeredCapital}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="成立日期">
                                    {HomeStore.detailData.establishmentDate}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="法人姓名">
                                    {HomeStore.detailData.legalPersonName}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="法人身份证号码">
                                    {HomeStore.detailData.legalPersonIdNumber}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="开户银行">
                                    {HomeStore.detailData.bankAccountName}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="开户银行账号">
                                    {HomeStore.detailData.bankAccountNumber}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="营业有效期">
                                    {HomeStore.detailData.businessExpireDate}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="营业执照">
                                    {HomeStore.detailData.businessLicenseImage && (
                                        <Image width={150} src={HomeStore.businessLicenseImage}/>)}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="开户许可证图片">
                                    {HomeStore.detailData.bankPermitImage && (
                                        <Image width={150} src={HomeStore.bankPermitImage}/>)}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="法人身份证正面">
                                    {HomeStore.detailData.legalPersonIdFront && (
                                        <Image width={150} src={HomeStore.legalPersonIdFront}/>)}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="法人身份证反面">
                                    {HomeStore.detailData.legalPersonIdBack && (
                                        <Image width={150} src={HomeStore.legalPersonIdBack}/>)}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            ),
        },
        {
            label: "准入材料",
            key: "3",
            show:['enterprise'],
            children: (
                <div>
                    <Form form={form} labelWrap>
                        <Row justify="start">
                            <Col span={12}>
                                <Form.Item label="工作号业务开通承诺函">
                                    {HomeStore.detailData?.businessCommitmentLetter?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="网络及信息安全承诺书">
                                    {HomeStore.detailData.networkSecurityCommitment?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="客户责任授权书">
                                    {HomeStore.detailData.customerResponsibilityAuthorization?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="规范使用业务承诺书">
                                    {HomeStore.detailData.businessUsageCommitment?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="工作号业务应用说明">
                                    {HomeStore.detailData.businessApplicationInstructions?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="话术模板">
                                    {HomeStore.detailData?.speechTemplate?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="社保证明">
                                    {HomeStore.detailData.socialSecurityProof?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="资质证明">
                                    {HomeStore.detailData.qualificationProof?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="合同链">
                                    {HomeStore.detailData.contractChain?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="场景使用说明">
                                    {HomeStore.detailData.scene?.map((item: any, index: number) => (
                                        <Button key={index} style={{maxWidth:'200px',textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',display:'block'}} onClick={()=>HomeStore.exportError(item.objectName)} type='link'>{item.fileName}</Button>))}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="使用场景">
                                    {HomeStore.detailData.sceneNames?.join(',')}
                                </Form.Item>
                            </Col>
                            {HomeStore.detailData.otherContents &&Object.entries(HomeStore.detailData.otherContents).map(([key, value]) =>
                                (<Col span={12}>
                                <Form.Item label={AddCompanyStore.oTherScenes.filter((item:any)=>item.label==key)[0]?.value}>
                                    {value as any}
                                </Form.Item>
                            </Col>))}
                        </Row>
                    </Form>
                </div>
            ),
        },
        {
            label: "经办人信息",
            key: "4",
            show:['account','enterprise'],
            children: (
                <div>
                    <Form form={form} labelWrap>
                        <Row justify="start">
                            <Col span={8}>
                                <Form.Item label="经办人身份">
                                    {HomeStore.detailData?.agentType == 0 ? '法定代表人' : '企业员工'}
                                </Form.Item>
                            </Col><Col span={8}>
                            <Form.Item label="经办人姓名">
                                {HomeStore.detailData?.agentName}
                            </Form.Item>
                        </Col><Col span={8}>
                            <Form.Item label="经办人手机号">
                                {HomeStore.detailData?.agentPhoneNumber}
                            </Form.Item>
                        </Col>
                        </Row>
                    </Form>
                </div>
            ),
        },
    ]
    const toCreate=()=>{
        HomeStore.setProcess('新增账户')
        AddCompanyStore.addCompanyModal.open('add')
    }
    const toChange=()=>{
        if (HomeStore.detailModal.enterprise){
            HomeStore.setProcess('企业认证变更')
            AddCompanyStore.addCompanyModal.open('update','企业认证变更')
        }else if (HomeStore.detailModal.account){
            HomeStore.setProcess('账户信息变更')
            AddCompanyStore.addCompanyModal.open('update','账户信息变更')
        }
    }
    return (
        <Fragment>
            <Modal
                width={"1000px"}
                centered
                title={HomeStore.detailModal.enterprise ? '企业认证' : '账户信息'}
                open={HomeStore.detailModal.isOpen}
                destroyOnClose={true}
                onCancel={() => HomeStore.detailModal.close()}
                footer={null}
                loading={HomeStore.detailModalLoading}
            >
                <Tabs
                    defaultActiveKey="1"
                    items={(CommonStore.homePageDataList.authStatus==='IN_PROGRESS')?tabsItem:HomeStore.detailModal.enterprise?tabsItem.filter((item:any,index:number)=>item.show.includes('enterprise')):tabsItem.filter((item:any,index:number)=>item.show.includes('account'))}
                />
                <Col span={24}>
                    <Form.Item style={{ textAlign: "right" }}>
                        <Space>
                            {((HomeStore.detailModal.enterprise &&CommonStore.homePageDataList.authStatus==='APPROVED')||
                                (HomeStore.detailModal.account &&CommonStore.homePageDataList.authStatus!=='FAILED' &&CommonStore.homePageDataList.authStatus!=='IN_PROGRESS'&&CommonStore.homePageDataList.authStatus))
                                &&<Button htmlType="reset" onClick={toChange}>变更</Button>}
                            <Button type="primary" onClick={()=>{HomeStore.detailModal.close()}}>
                                关闭
                            </Button>
                        </Space>
                    </Form.Item>
                </Col>
                {HomeStore.detailModal.enterprise &&CommonStore.homePageDataList.authStatus==='APPROVED'&&
                    <div>企业已完成实名认证，去<a onClick={toCreate}>创建</a>新账户</div>}
            </Modal>
        </Fragment>
    );
}

export default observer(RowDetail);
